import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import { SessionActions } from "../actions/guideStreamActions";

export default function upcomingMentorReducer(state = initialState.upcomingMentors, action: SessionActions) {
    switch (action.type) {
        case types.LOAD_UPCOMING_MENTORS_SUCCESS:
            return action.upcomingMentors;
        default:
            return state;
    }
}
